import { useEffect, useState } from "react";
import { Trophy, Crown } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { fmtCoins } from "./ClickerLayout";

const BOARDS = [["coins", "Total coins"], ["level", "Level"], ["achievements", "Achievements"]];

export default function ClickerRanks() {
  const { user } = useAuth();
  const [by, setBy] = useState("coins");
  const [rows, setRows] = useState(null);
  useEffect(() => { setRows(null); api.get("/clicker/leaderboard", { params: { by } }).then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, [by]);
  const val = (r) => (by === "coins" ? `${fmtCoins(r.total_earned)}` : by === "level" ? `Lv ${r.level}` : `${r.ach_n} badges`);
  return (
    <div className="space-y-4" data-testid="clicker-ranks">
      <h2 className="font-black text-xl flex items-center gap-2"><Trophy className="w-5 h-5 text-[#FFE300]" /> Leaderboards</h2>
      <div className="flex gap-2">
        {BOARDS.map(([k, l]) => (
          <button key={k} onClick={() => setBy(k)} data-testid={`clicker-board-${k}`}
            className={`text-xs font-bold px-3 py-1.5 rounded-full border transition-colors ${by === k ? "border-[#FF2BD6] bg-[#FF2BD6]/15 text-[#FF2BD6]" : "border-white/10 text-white/50"}`}>{l}</button>
        ))}
      </div>
      {!rows ? <div className="text-white/40 text-sm animate-pulse">Loading…</div> : rows.length === 0 ? <div className="text-white/40 text-sm">No players yet.</div> : (
        <ol className="space-y-1.5">
          {rows.map((r, i) => (
            <li key={r.user_id} data-testid={`clicker-rank-row-${i}`}
              className={`flex items-center gap-3 rounded-xl px-3 py-2.5 border ${r.user_id === user?.id ? "border-[#00F0FF]/50 bg-[#00F0FF]/10" : "border-white/5 bg-white/5"}`}>
              <span className={`w-7 text-center font-black ${i < 3 ? "text-[#FFE300]" : "text-white/40"}`}>{i === 0 ? <Crown className="w-4 h-4 mx-auto" /> : i + 1}</span>
              <span className="flex-1 font-bold truncate">{r.name}</span>
              <span className="font-black text-sm">{val(r)}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
